

import { Alert } from 'antd';
import React, { useEffect ,useState} from 'react';

const ErrorMessage = ({ msg, onClose }) => {
  const [message, setMessage] = useState();
  useEffect(() => {
    if (msg) {
      setMessage(msg)
    }
  }, [msg])
  const closeErrorMessage = () => {
    setMessage(null);
    if (onClose) {
      onClose();
    }
  }
  return (
    <div>
      {message && <Alert
        className="w-100 mb-10 px-3 py-4 banks-errmsg icon-bg items-center"
        type="error"
        description={message}
        showIcon
        onClose={closeErrorMessage}
        closable
      />}
    </div>
  );
};
export default ErrorMessage;

